import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { FieldPropTypes } from '@entrata/shared/lib/components/forms/propTypes';
import { FieldAdapter } from '@entrata/shared/lib/components/forms/form';
import { PhoneInput, FieldStructure } from "../atoms";

// TODO: migrate all the PhoneField components into one component
// with a few dynamic props to reduce boilerplate:

/** `PhoneInput` wrapped in standard `FieldStructure` */
import { jsx as ___EmotionJSX } from "@emotion/core";
const PhoneField = props => ___EmotionJSX(FieldAdapter, _extends({
  validate: PhoneInput.validate,
  inputType: PhoneInput.inputType
}, props), fieldProps => ___EmotionJSX(FieldStructure, fieldProps, ___EmotionJSX(PhoneInput, fieldProps)));
PhoneField.propTypes = _extends({}, FieldPropTypes.propTypes, {
  /** Field Label */
  label: PropTypes.node,
  /** Input placeholder */
  placeholder: PropTypes.string,
  /** Value of the input */
  value: PropTypes.string
});
export { PhoneField };